import { useEffect, useRef } from 'react';

export const useRipple = () => {
    const rippleRef = useRef(null);

    useEffect(() => {
        const element = rippleRef.current;
        if (!element) return;

        const createRipple = (event) => {
            const ripple = document.createElement('span');
            const rect = element.getBoundingClientRect();

            const size = Math.max(rect.width, rect.height);
            const x = event.clientX - rect.left - size / 2;
            const y = event.clientY - rect.top - size / 2;

            ripple.style.width = ripple.style.height = `${size}px`;
            ripple.style.left = `${x}px`;
            ripple.style.top = `${y}px`;
            ripple.className = 'ripple-effect';

            element.appendChild(ripple);

            ripple.addEventListener('animationend', () => {
                ripple.remove();
            });
        };

        element.addEventListener('mousedown', createRipple);

        return () => {
            element.removeEventListener('mousedown', createRipple);
        };
    }, []);

    return rippleRef;
};
